import {
  Backdrop,
  Button,
  Card,
  CardContent,
  CardHeader, Chip,
  Container,
  Divider,
  Grid,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  IconButton,
  Menu,
  MenuItem,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
} from "@mui/material";
import React, {useEffect, useState} from "react";
import {useSnackbar} from "notistack";
import {useParams} from "react-router-dom";
import {Helmet} from "react-helmet";
import {api} from "../../../services/Main/Api";
import CircularProgress from "@mui/material/CircularProgress";
import AddIcon from "@mui/icons-material/Add";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import RentRecipientModalForm from "./RentRecipientModalForm";
import {getCondoId} from "../../../services/Main/AuthStorage";
import PhoneFormatter from "../../../components/PhoneFormatter/PhoneFormater";

const RentRecipientDetail = () => {

  const params = useParams()
  const { id } = params

  const {enqueueSnackbar} = useSnackbar()

  const [isLoading, setIsLoading] = useState(!!id)

  // -> Recipient data
  const [data, setData] = useState(null)

  const [openModal, setOpenModal] = useState(false);

  // Dropdown menu states
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedAccountId, setSelectedAccountId] = useState(null);

  // Confirmation dialog state
  const [openConfirmDialog, setOpenConfirmDialog] = useState(false);

  const handleAddDataPix = () => setOpenModal(true);
  const handleCloseModal = () => setOpenModal(false);

  // Dropdown menu handlers
  const handleMenuOpen = (event, accountId) => {
    setAnchorEl(event.currentTarget);
    setSelectedAccountId(accountId);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);

  };

  // Confirmation dialog handlers
  const handleOpenConfirmDialog = () => {
    setOpenConfirmDialog(true);
    handleMenuClose(); // Fecha o menu ao abrir o diálogo
  };

  const handleCloseConfirmDialog = () => {
    setOpenConfirmDialog(false);
    setSelectedAccountId(null);
  };

  //// => Get

  function getRecipient () {
    setIsLoading(true)
    api.get(`rent_recipient/${id}/`)
        .then(response => {
          setData(response.data)
        })
        .catch(error => {
          console.log(error)
        })
        .finally(() => {
          setIsLoading(false)
        })
  }

  //// => Post & Update
  const handleSubmitAccount = (formData) => {
    setIsLoading(true)
    if (formData.type === "pix") {
      let pixKeyValue = formData.pixKey.toString().replace(/[^a-zA-Z0-9]/gi, '');
      if (parseInt(formData.pixType) === 3) {
        pixKeyValue = `+55${pixKeyValue}`
      }
      api.post("/rent_recipient/account/", {
        rent_recipient: id,
        pix_key_value: pixKeyValue,
        pix_key_type: formData.pixType,
        account_type: formData.type.toUpperCase(),
        account: +getCondoId(),
      })
          .then(() => {
            enqueueSnackbar("Chave PIX cadastrada!", { variant: "success" });
            getRecipient();
          })
          .catch(() => enqueueSnackbar("Erro ao cadastrar PIX", { variant: "error" }))
          .finally(() => {
            setIsLoading(false)
          });
    } else {
      api.post("/rent_recipient/account/", {
        rent_recipient: id,
        bank_branch: formData.agency,
        bank_account: formData.accountNumber,
        bank_account_digit: formData.accountDigit,
        bank: formData.bank,
        account_type: formData.type.toUpperCase(),
        bank_account_type: formData.accountType,
        account: +getCondoId(),
      })
          .then(() => {
            enqueueSnackbar("Conta cadastrada!", { variant: "success" });
            getRecipient();
          })
          .catch(() => enqueueSnackbar("Erro ao cadastrar conta", { variant: "error" }))
          .finally(() => {
            setIsLoading(false)
          });
    }
  };

  //// => Delete
  function deleteAccountById () {
    if (selectedAccountId == null) return;
    setIsLoading(true)
    api.delete(`/rent_recipient/account/${selectedAccountId}/`)
        .then(response => {
          enqueueSnackbar('Conta deletada', { variant: 'success' });
          getRecipient();
        })
        .catch(error => {
          if (error.response?.data?.[0]) {
            enqueueSnackbar(error.response.data[0], { variant: 'error' });
          } else {
            enqueueSnackbar('Erro ao excluir conta', { variant: 'error' });
          }
          console.log(error);
        })
        .finally(() => {
          handleCloseConfirmDialog();
          setIsLoading(false)
        });
  }

  useEffect(function whenUpdate(){
    getRecipient()
  }, [])

  // Cristian code
  const formatPixKey = (value, keyType) => {
    let formattedValue = value;
    switch (parseInt(keyType)) {
      case 0: // CPF
        const cpfNumbers = value.replace(/\D/g, '');
        if (cpfNumbers.length === 11) {
          formattedValue = cpfNumbers.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4');
        }
        break;
      case 1: // CNPJ
        const cnpjNumbers = value.replace(/\D/g, '');
        if (cnpjNumbers.length === 14) {
          formattedValue = cnpjNumbers.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, '$1.$2.$3/$4-$5');
        }
        break;
      case 2: // E-mail
        formattedValue = value;
        break;
      case 3: // Celular
        const phoneNumbers = value.replace(/\D/g, '');
        if (phoneNumbers.length === 11) {
          formattedValue = phoneNumbers.replace(/(\d{2})(\d{5})(\d{4})/, '($1) $2-$3');
        } else if (phoneNumbers.length === 10) {
          formattedValue = phoneNumbers.replace(/(\d{2})(\d{4})(\d{4})/, '($1) $2-$3');
        } else if (phoneNumbers.length === 9) {
          formattedValue = phoneNumbers.replace(/(\d{5})(\d{4})/, '$1-$2');
        } else if (phoneNumbers.length === 8) {
          formattedValue = phoneNumbers.replace(/(\d{4})(\d{4})/, '$1-$2');
        }
        break;
      case 4: // Chave aleatória
      default:
        formattedValue = value;
        break;
    }
    return formattedValue;
  };

  return (
      <>
        <Helmet>
          <title>{`Beneficiário - Bloco B3`}</title>
        </Helmet>

        <Container maxWidth={false}>
          <Grid container spacing={2}
                sx={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'top'
                }}
          >
            <Grid item xs={12} lg={4}>
              <Card>
                <CardHeader title={"Beneficiário"} sx={{color:"#F40863"}}/>
                <Divider/>
                <CardContent>
                  <Table>
                    <TableBody>
                      <TableRow>
                        <TableCell>Nome</TableCell>
                        <TableCell>{data?.name}</TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell>CPF/CNPJ</TableCell>
                        <TableCell>{data?.cpf_cnpj}</TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell>Telefone</TableCell>
                        <TableCell>
                          <PhoneFormatter country={data?.country} phone={data?.phone} />
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell>Email</TableCell>
                        <TableCell>{data?.email}</TableCell>
                      </TableRow>
                    </TableBody>
                  </Table>
                </CardContent>
              </Card>
            </Grid>
            <Grid item xs={12} lg={8}>
              <Card>
                <CardHeader title={`Contas Bancárias`} sx={{color:"#F40863"}} action={
                  <Button
                      variant="contained"
                      startIcon={<AddIcon/>}
                      size="small"
                      onClick={handleAddDataPix}
                  >
                    Adicionar
                  </Button>
                }/>
                <Divider/>
                <CardContent>
                  {data?.pix_accounts.length > 0 && <Table>
                    <TableHead>
                      <TableRow>
                        <TableCell>Chave</TableCell>
                        <TableCell>Nome do Favorecido</TableCell>
                        <TableCell>Banco</TableCell>
                        <TableCell>Utlizada em</TableCell>
                        <TableCell></TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {data?.pix_accounts.map(account => (
                          <TableRow key={account.id}>
                            <TableCell>{formatPixKey(account.pix_key_value, account.pix_key_type?.id)}</TableCell>
                            <TableCell>{account.name}</TableCell>
                            <TableCell>{account.bank}</TableCell>
                            <TableCell>
                              <Chip  size={'small'} label={account.counter > 1 ? `${account.counter} contratos` : `${account.counter} contrato`}/>
                            </TableCell>
                            <TableCell align="right">
                              {account.counter === 0 && <IconButton
                                  aria-label="more"
                                  aria-controls="pix-action-menu"
                                  aria-haspopup="true"
                                  onClick={e => handleMenuOpen(e, account.id)}
                              >
                                <MoreVertIcon />
                              </IconButton>}
                            </TableCell>
                          </TableRow>
                      ))}
                    </TableBody>
                  </Table> }
                </CardContent>
                <CardContent>
                  {data?.ted_accounts.length > 0 && <Table>
                    <TableHead>
                      <TableRow>
                        <TableCell>Agencia</TableCell>
                        <TableCell>Conta Corrente</TableCell>
                        <TableCell>Tipo da Conta</TableCell>
                        <TableCell>Banco</TableCell>
                        <TableCell>Utlizada em</TableCell>
                        <TableCell></TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {data?.ted_accounts.map(account => (
                          <TableRow key={account.id}>
                            <TableCell>{account.bank_branch}</TableCell>
                            <TableCell>{account.bank_account}</TableCell>
                            <TableCell>{account.bank_account_type === 1 ? "Poupança" : "Conta Corrente"}</TableCell>
                            <TableCell>{account.bank}</TableCell>

                            <TableCell>
                              <Chip size={'small'} label={account.counter > 1 ? `${account.counter} contratos` : `${account.counter} contrato`}/>
                            </TableCell>
                            <TableCell align="right">
                              {account.counter === 0 && <IconButton
                                  aria-label="more"
                                  aria-controls="ted-action-menu"
                                  aria-haspopup="true"
                                  onClick={e => handleMenuOpen(e, account.id)}
                              >
                                <MoreVertIcon />
                              </IconButton> }
                            </TableCell>
                          </TableRow>
                      ))}
                    </TableBody>
                  </Table> }
                </CardContent>
              </Card>
            </Grid>
          </Grid>
        </Container>

        {/* Menu Dropdown para exclusão */}
        <Menu
            id="action-menu"
            anchorEl={anchorEl}
            open={Boolean(anchorEl)}
            onClose={handleMenuClose}
            anchorOrigin={{
              vertical: 'top',
              horizontal: 'right',
            }}
            transformOrigin={{
              vertical: 'top',
              horizontal: 'right',
            }}
        >
          <MenuItem onClick={handleOpenConfirmDialog}>
            <DeleteOutlineIcon fontSize="small" sx={{ mr: 1 }} />
            Excluir
          </MenuItem>
        </Menu>

        {/* Diálogo de confirmação */}
        <Dialog
            open={openConfirmDialog}
            onClose={handleCloseConfirmDialog}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">
            Confirmar exclusão
          </DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              Tem certeza que deseja excluir?
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleCloseConfirmDialog} color="primary">
              Cancelar
            </Button>
            <Button onClick={deleteAccountById} color="error" autoFocus>
              Excluir
            </Button>
          </DialogActions>
        </Dialog>

        <RentRecipientModalForm
            open={openModal}
            onClose={handleCloseModal}
            onSubmit={handleSubmitAccount}
            cpfCnpj={data?.cpf_cnpj}
            email={data?.email}
            phone={data?.phone}
        />

        <Backdrop
            sx={{ color: '#fff', zIndex: 1500, }}
            open={isLoading}
        >
          <CircularProgress color="inherit"/>
        </Backdrop>

      </>
  )
}

export default RentRecipientDetail